import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import IndicatorsBox from "../../component/IndicatorsBox";
import { Link } from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography variant="caption">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function Indicators(props) {
  //console.log("props", props);
  const indicators = props.indicators;
  const showIndicators = props.showIndicators;
  const techdata = props.techdata;
  const classes = useStyles();

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div className={classes.root}>
        {showIndicators === 0 && (
          <div className="row mt-4">
            <div className="col-12 text-center mt-4 mb-4">
              <Link
                to="/subscription"
                target="_blank"
                className="btn btn-primary"
              >
                To access All scan service make payment and enjoy data
              </Link>
            </div>
          </div>
        )}
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <Tab label="Daily" {...a11yProps(0)} />
            <Tab label="Weekly" {...a11yProps(1)} />
            <Tab label="Monthly" {...a11yProps(2)} />
            <Tab label="SMA/EMA" {...a11yProps(3)} />
          </Tabs>
        </AppBar>
        <TabPanel className="customtabpanel" value={value} index={0}>
          <div className="table-responsive">
            <table className="table table-bordered ">
              <thead>
                <tr>
                  <th>Parameters</th>
                  <th>Pre Value</th>
                  <th>Cur Value</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <IndicatorsBox
                  keys="<b>RSI(14)</b>"
                  preValue={indicators?.RSI[0]?.RSI}
                  currValue={indicators?.RSI[1]?.RSI}
                  extraKey="RSI"
                />
                <tr>
                  <td colSpan="4">
                    <b>STOCH(5,3)</b>
                  </td>
                </tr>
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Slow D"
                  preValue={indicators?.STOCH[0]?.STOCH?.dPer}
                  currValue={indicators?.STOCH[1]?.STOCH?.dPer}
                  extraKey="STOCH"
                  oldKper={indicators?.STOCH[0]?.STOCH?.kPer}
                  CurrKPer={indicators?.STOCH[1]?.STOCH?.kPer}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Slow K"
                  preValue={indicators?.STOCH[0]?.STOCH?.kPer}
                  currValue={indicators?.STOCH[1]?.STOCH?.kPer}
                />
                <IndicatorsBox
                  keys="<b>MACD(12,26) </b>"
                  preValue={indicators?.MACD[0]?.MACD?.macdLine}
                  currValue={indicators?.MACD[1]?.MACD?.macdLine}
                  extraKey="MACD"
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Signal"
                  preValue={indicators?.MACD[0]?.MACD?.allEMA}
                  currValue={indicators?.MACD[1]?.MACD?.allEMA}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Histogram"
                  preValue={indicators?.MACD[0]?.MACD?.macdHistogra}
                  currValue={indicators?.MACD[1]?.MACD?.macdHistogra}
                />

                <IndicatorsBox
                  keys="<b>WILLR</b>"
                  preValue={indicators?.WILLR[0]?.WILLR}
                  currValue={indicators?.WILLR[1]?.WILLR}
                  extraKey="WILLR"
                />
                <IndicatorsBox
                  keys="<b>ADX(14)</b>"
                  preValue={indicators?.ADX[0]?.ADX?.finalDX}
                  currValue={indicators?.ADX[1]?.ADX?.finalDX}
                  extraKey="ADX"
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-(DI+)"
                  preValue={indicators?.ADX[0]?.ADX?.plusDIValue}
                  currValue={indicators?.ADX[1]?.ADX?.plusDIValue}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-(DI-)"
                  preValue={indicators?.ADX[0]?.ADX?.minusDIValue}
                  currValue={indicators?.ADX[1]?.ADX?.minusDIValue}
                />
                <IndicatorsBox
                  keys="<b>CCI(14)</b>"
                  preValue={indicators?.CCI[0]?.CCI?.CCIValue}
                  currValue={indicators?.CCI[1]?.CCI?.CCIValue}
                  extraKey="CCI"
                />
                <tr>
                  <td colSpan="4">
                    <b>BBRANDS</b>
                  </td>
                </tr>
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Upper Band"
                  preValue={indicators?.BOLLI[0]?.BOLLI?.upperBand}
                  currValue={indicators?.BOLLI[1]?.BOLLI?.upperBand}
                  extraKey="BBRANDS"
                  ltp={techdata?.ltp}
                  middleBand={indicators?.BOLLI[1]?.BOLLI?.middleBand}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Middle Band"
                  preValue={indicators?.BOLLI[0]?.BOLLI?.middleBand}
                  currValue={indicators?.BOLLI[1]?.BOLLI?.middleBand}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Lower Band"
                  preValue={indicators?.BOLLI[0]?.BOLLI?.lowerBand}
                  currValue={indicators?.BOLLI[1]?.BOLLI?.lowerBand}
                />
                <IndicatorsBox
                  keys="<b>ATR(14)</b>"
                  preValue={indicators?.ATR[0]?.ATR}
                  currValue={indicators?.ATR[1]?.ATR}
                  extraKey="ATR"
                />
                <IndicatorsBox
                  keys="<b>OBV</b>"
                  preValue={indicators?.OBV[0]?.OBV}
                  currValue={indicators?.OBV[1]?.OBV}
                  extraKey="OBV"
                />
                <tr>
                  <td colSpan="4">
                    <b>Supertrend</b>
                  </td>
                </tr>
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Up"
                  preValue={indicators?.SUPER[0]?.SUPER?.up}
                  currValue={indicators?.SUPER[1]?.SUPER?.up}
                  extraKey="Supertrend"
                  ltp={techdata?.ltp}
                  high={indicators?.SUPER[1]?.SUPER?.high}
                  preLow={indicators?.SUPER[0]?.SUPER?.low}
                />

                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Down"
                  preValue={indicators?.SUPER[0]?.SUPER?.down}
                  currValue={indicators?.SUPER[1]?.SUPER?.down}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-High"
                  preValue={indicators?.SUPER[0]?.SUPER?.high}
                  currValue={indicators?.SUPER[1]?.SUPER?.high}
                />

                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Low"
                  preValue={indicators?.SUPER[0]?.SUPER?.low}
                  currValue={indicators?.SUPER[1]?.SUPER?.low}
                />
              </tbody>
            </table>
          </div>
        </TabPanel>
        <TabPanel className="customtabpanel" value={value} index={1}>
          <div className="table-responsive">
            <table className="table table-bordered ">
              <thead>
                <tr>
                  <th>Parameters</th>
                  <th>Pre Value</th>
                  <th>Cur Value</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <IndicatorsBox
                  keys="<b>RSI(14)</b>"
                  preValue={indicators?.WRSI[0]?.WRSI}
                  currValue={indicators?.WRSI[1]?.WRSI}
                  extraKey="RSI"
                />
                <tr>
                  <td colSpan="4">
                    <b>STOCH(5,3)</b>
                  </td>
                </tr>
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Slow D"
                  preValue={indicators?.WSTOCH[0]?.WSTOCH?.dPer}
                  currValue={indicators?.WSTOCH[1]?.WSTOCH?.dPer}
                  extraKey="STOCH"
                  oldKper={indicators?.WSTOCH[0]?.WSTOCH?.kPer}
                  CurrKPer={indicators?.WSTOCH[1]?.WSTOCH?.kPer}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Slow K"
                  preValue={indicators?.WSTOCH[0]?.WSTOCH?.kPer}
                  currValue={indicators?.WSTOCH[1]?.WSTOCH?.kPer}
                />
                <IndicatorsBox
                  keys="<b>MACD(12,26)</b>"
                  preValue={indicators?.WMACD[0]?.WMACD?.macdLine}
                  currValue={indicators?.WMACD[1]?.WMACD?.macdLine}
                  extraKey="MACD"
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Signal"
                  preValue={indicators?.WMACD[0]?.WMACD?.allEMA}
                  currValue={indicators?.WMACD[1]?.WMACD?.allEMA}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Histogram"
                  preValue={indicators?.WMACD[0]?.WMACD?.macdHistogra}
                  currValue={indicators?.WMACD[1]?.WMACD?.macdHistogra}
                />

                <IndicatorsBox
                  keys="<b>WILLR</b>"
                  preValue={indicators?.WWILLR[0]?.WWILLR}
                  currValue={indicators?.WWILLR[1]?.WWILLR}
                  extraKey="WILLR"
                />
                <IndicatorsBox
                  keys="<b>ADX(14)</b>"
                  preValue={indicators?.WADX[0]?.WADX?.finalDX}
                  currValue={indicators?.WADX[1]?.WADX?.finalDX}
                  extraKey="ADX"
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-DI+"
                  preValue={indicators?.WADX[0]?.ADX?.plusDIValue}
                  currValue={indicators?.WADX[1]?.ADX?.plusDIValue}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-DI-"
                  preValue={indicators?.WADX[0]?.WADX?.minusDIValue}
                  currValue={indicators?.WADX[1]?.WADX?.minusDIValue}
                />
                <IndicatorsBox
                  keys="<b>CCI(14)</b>"
                  preValue={indicators?.WCCI[0]?.WCCI?.CCIValue}
                  currValue={indicators?.WCCI[1]?.WCCI?.CCIValue}
                  extraKey="CCI"
                />
                <tr>
                  <td colSpan="4">
                    <b>BBRANDS</b>
                  </td>
                </tr>
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Upper Band"
                  preValue={indicators?.WBOLLI[0]?.WBOLLI?.upperBand}
                  currValue={indicators?.WBOLLI[1]?.WBOLLI?.upperBand}
                  extraKey="BBRANDS"
                  ltp={techdata?.ltp}
                  middleBand={indicators?.WBOLLI[1]?.WBOLLI?.middleBand}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Middle Band"
                  preValue={indicators?.WBOLLI[0]?.WBOLLI?.middleBand}
                  currValue={indicators?.WBOLLI[1]?.WBOLLI?.middleBand}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Lower Band"
                  preValue={indicators?.WBOLLI[0]?.WBOLLI?.lowerBand}
                  currValue={indicators?.WBOLLI[1]?.WBOLLI?.lowerBand}
                />
                <IndicatorsBox
                  keys="<b>ATR(14)</b>"
                  preValue={indicators?.WATR[0]?.WATR}
                  currValue={indicators?.WATR[1]?.WATR}
                  extraKey="ATR"
                />
                <IndicatorsBox
                  keys="<b>OBV</b>"
                  preValue={indicators?.WOBV[0]?.WOBV}
                  currValue={indicators?.WOBV[1]?.WOBV}
                  extraKey="OBV"
                />
                <tr>
                  <td colSpan="4">
                    <b>Supertrend</b>
                  </td>
                </tr>
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Up"
                  preValue={indicators?.WSUPER[0]?.SUPER?.up}
                  currValue={indicators?.WSUPER[1]?.SUPER?.up}
                  extraKey="Supertrend"
                  ltp={techdata?.ltp}
                  high={indicators?.WSUPER[1]?.SUPER?.high}
                  preLow={indicators?.WSUPER[0]?.SUPER?.low}
                />

                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Down"
                  preValue={indicators?.WSUPER[0]?.SUPER?.down}
                  currValue={indicators?.WSUPER[1]?.SUPER?.down}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-High"
                  preValue={indicators?.WSUPER[0]?.SUPER?.high}
                  currValue={indicators?.WSUPER[1]?.SUPER?.high}
                />

                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Low"
                  preValue={indicators?.WSUPER[0]?.SUPER?.low}
                  currValue={indicators?.WSUPER[1]?.SUPER?.low}
                />
              </tbody>
            </table>
          </div>
        </TabPanel>
        <TabPanel className="customtabpanel" value={value} index={2}>
          <div className="table-responsive">
            <table className="table table-bordered ">
              <thead>
                <tr>
                  <th>Parameters</th>
                  <th>Pre Value</th>
                  <th>Cur Value</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <IndicatorsBox
                  keys="<b>RSI(14)</b>"
                  preValue={indicators?.MRSI[0]?.MRSI}
                  currValue={indicators?.MRSI[1]?.MRSI}
                  extraKey="RSI"
                />
                <tr>
                  <td colSpan="4">
                    <b>STOCH(5,3)</b>
                  </td>
                </tr>
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Slow D"
                  preValue={indicators?.MSTOCH[0]?.MSTOCH?.dPer}
                  currValue={indicators?.MSTOCH[1]?.MSTOCH?.dPer}
                  extraKey="STOCH"
                  oldKper={indicators?.MSTOCH[0]?.MSTOCH?.kPer}
                  CurrKPer={indicators?.MSTOCH[1]?.MSTOCH?.kPer}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Slow K"
                  preValue={indicators?.MSTOCH[0]?.MSTOCH?.kPer}
                  currValue={indicators?.MSTOCH[1]?.MSTOCH?.kPer}
                />
                <IndicatorsBox
                  keys="<b>MACD(12,26)</b>"
                  preValue={indicators?.MMACD[0]?.MMACD?.macdLine}
                  currValue={indicators?.MMACD[1]?.MMACD?.macdLine}
                  extraKey="MACD"
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Signal"
                  preValue={indicators?.MMACD[0]?.MMACD?.allEMA}
                  currValue={indicators?.MMACD[1]?.MMACD?.allEMA}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Histogram"
                  preValue={indicators?.MMACD[0]?.MMACD?.macdHistogra}
                  currValue={indicators?.MMACD[1]?.MMACD?.macdHistogra}
                />

                <IndicatorsBox
                  keys="<b>WILLR</b>"
                  preValue={indicators?.MWILLR[0]?.MWILLR}
                  currValue={indicators?.MWILLR[1]?.MWILLR}
                  extraKey="WILLR"
                />
                <IndicatorsBox
                  keys="<b>ADX(14)</b>"
                  preValue={indicators?.MADX[0]?.MADX?.finalDX}
                  currValue={indicators?.MADX[1]?.MADX?.finalDX}
                  extraKey="ADX"
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-DI+"
                  preValue={indicators?.MADX[0]?.ADX?.plusDIValue}
                  currValue={indicators?.MADX[1]?.ADX?.plusDIValue}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-DI-"
                  preValue={indicators?.MADX[0]?.MADX?.minusDIValue}
                  currValue={indicators?.MADX[1]?.MADX?.minusDIValue}
                />
                <IndicatorsBox
                  keys="<b>CCI(14)</b>"
                  preValue={indicators?.MCCI[0]?.MCCI?.CCIValue}
                  currValue={indicators?.MCCI[1]?.MCCI?.CCIValue}
                  extraKey="CCI"
                />
                <tr>
                  <td colSpan="4">
                    <b>BBRANDS</b>
                  </td>
                </tr>
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Upper Band"
                  preValue={indicators?.MBOLLI[0]?.MBOLLI?.upperBand}
                  currValue={indicators?.MBOLLI[1]?.MBOLLI?.upperBand}
                  extraKey="BBRANDS"
                  ltp={techdata?.ltp}
                  middleBand={indicators?.MBOLLI[1]?.MBOLLI?.middleBand}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Middle Band"
                  preValue={indicators?.MBOLLI[0]?.MBOLLI?.middleBand}
                  currValue={indicators?.MBOLLI[1]?.MBOLLI?.middleBand}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Lower Band"
                  preValue={indicators?.MBOLLI[0]?.MBOLLI?.lowerBand}
                  currValue={indicators?.MBOLLI[1]?.MBOLLI?.lowerBand}
                />
                <IndicatorsBox
                  keys="<b>ATR(14)</b>"
                  preValue={indicators?.MATR[0]?.MATR}
                  currValue={indicators?.MATR[1]?.MATR}
                  extraKey="ATR"
                />
                <IndicatorsBox
                  keys="<b>OBV</b>"
                  preValue={indicators?.MOBV[0]?.MOBV}
                  currValue={indicators?.MOBV[1]?.MOBV}
                  extraKey="OBV"
                />
                <tr>
                  <td colSpan="4">
                    <b>Supertrend</b>
                  </td>
                </tr>
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Up"
                  preValue={indicators?.MSUPER[0]?.SUPER?.up}
                  currValue={indicators?.MSUPER[1]?.SUPER?.up}
                  extraKey="Supertrend"
                  ltp={techdata?.ltp}
                  high={indicators?.MSUPER[1]?.SUPER?.high}
                  preLow={indicators?.MSUPER[0]?.SUPER?.low}
                />

                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Down"
                  preValue={indicators?.MSUPER[0]?.SUPER?.down}
                  currValue={indicators?.MSUPER[1]?.SUPER?.down}
                />
                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-High"
                  preValue={indicators?.MSUPER[0]?.SUPER?.high}
                  currValue={indicators?.MSUPER[1]?.SUPER?.high}
                />

                <IndicatorsBox
                  keys="&nbsp;&nbsp;&nbsp;&nbsp;-Low"
                  preValue={indicators?.MSUPER[0]?.SUPER?.low}
                  currValue={indicators?.MSUPER[1]?.SUPER?.low}
                />
              </tbody>
            </table>
          </div>
        </TabPanel>
        <TabPanel
          className="customtabpanel customTablePanel"
          value={value}
          index={3}
        >
          <div className="row">
            <div className="col-sm-6">
              <h3 className="highlighttext">Daily Data</h3>
              <div className="table-responsive">
                <table className="table table-bordered ">
                  <thead>
                    <tr>
                      <th>Period</th>
                      <th>SMA</th>
                      <th>EMA</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <IndicatorsBox
                      keys="<b>5 </b>"
                      preValue={indicators?.EMA[1]?.EMA?.emaData?.sfivedma}
                      currValue={indicators?.EMA[1]?.EMA?.smaData?.sfivedmaCal}
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>10 </b>"
                      preValue={indicators?.EMA[1]?.EMA?.emaData?.stendma}
                      currValue={indicators?.EMA[1]?.EMA?.smaData?.stendmaCal}
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>20 </b>"
                      preValue={indicators?.EMA[1]?.EMA?.emaData?.stwentydma}
                      currValue={
                        indicators?.EMA[1]?.EMA?.smaData?.stwentydmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>30 </b>"
                      preValue={indicators?.EMA[1]?.EMA?.emaData?.sthirtydma}
                      currValue={
                        indicators?.EMA[1]?.EMA?.smaData?.sthirtydmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>34 </b>"
                      preValue={
                        indicators?.EMA[1]?.EMA?.emaData?.sthirtyfourdma
                      }
                      currValue={
                        indicators?.EMA[1]?.EMA?.smaData?.sthirtyfourdmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>50 </b>"
                      preValue={indicators?.EMA[1]?.EMA?.emaData?.sfiftydma}
                      currValue={indicators?.EMA[1]?.EMA?.smaData?.sfiftydmaCal}
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>89 </b>"
                      preValue={
                        indicators?.EMA[1]?.EMA?.emaData?.seightyninedma
                      }
                      currValue={
                        indicators?.EMA[1]?.EMA?.smaData?.seightyninedmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>100 </b>"
                      preValue={indicators?.EMA[1]?.EMA?.emaData?.shundreddma}
                      currValue={
                        indicators?.EMA[1]?.EMA?.smaData?.shundreddmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>150 </b>"
                      preValue={indicators?.EMA[1]?.EMA?.emaData?.sonefiftydma}
                      currValue={
                        indicators?.EMA[1]?.EMA?.smaData?.sonefiftydmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>200 </b>"
                      preValue={
                        indicators?.EMA[1]?.EMA?.emaData?.stwohundreddma
                      }
                      currValue={
                        indicators?.EMA[1]?.EMA?.smaData?.stwohundreddmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-sm-6">
              <h3 className="highlighttext">Weekly Data</h3>
              <div className="table-responsive">
                <table className="table table-bordered subscptionTable ">
                  <thead>
                    <tr>
                      <th>Period</th>
                      <th>SMA</th>
                      <th>EMA</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <IndicatorsBox
                      keys="<b>5 </b>"
                      preValue={indicators?.WEMA[1]?.WEMA?.emaData?.sfivedma}
                      currValue={
                        indicators?.WEMA[1]?.WEMA?.smaData?.sfivedmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>10 </b>"
                      preValue={indicators?.WEMA[1]?.WEMA?.emaData?.stendma}
                      currValue={indicators?.WEMA[1]?.WEMA?.smaData?.stendmaCal}
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>20 </b>"
                      preValue={indicators?.WEMA[1]?.WEMA?.emaData?.stwentydma}
                      currValue={
                        indicators?.WEMA[1]?.WEMA?.smaData?.stwentydmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>30 </b>"
                      preValue={indicators?.WEMA[1]?.WEMA?.emaData?.sthirtydma}
                      currValue={
                        indicators?.WEMA[1]?.WEMA?.smaData?.sthirtydmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>34 </b>"
                      preValue={
                        indicators?.WEMA[1]?.WEMA?.emaData?.sthirtyfourdma
                      }
                      currValue={
                        indicators?.WEMA[1]?.WEMA?.smaData?.sthirtyfourdmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>50 </b>"
                      preValue={indicators?.WEMA[1]?.WEMA?.emaData?.sfiftydma}
                      currValue={
                        indicators?.WEMA[1]?.WEMA?.smaData?.sfiftydmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>89 </b>"
                      preValue={
                        indicators?.WEMA[1]?.WEMA?.emaData?.seightyninedma
                      }
                      currValue={
                        indicators?.WEMA[1]?.WEMA?.smaData?.seightyninedmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>100 </b>"
                      preValue={indicators?.WEMA[1]?.WEMA?.emaData?.shundreddma}
                      currValue={
                        indicators?.WEMA[1]?.WEMA?.smaData?.shundreddmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>150 </b>"
                      preValue={
                        indicators?.WEMA[1]?.WEMA?.emaData?.sonefiftydma
                      }
                      currValue={
                        indicators?.WEMA[1]?.WEMA?.smaData?.sonefiftydmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                    <IndicatorsBox
                      keys="<b>200 </b>"
                      preValue={
                        indicators?.WEMA[1]?.WEMA?.emaData?.stwohundreddma
                      }
                      currValue={
                        indicators?.WEMA[1]?.WEMA?.smaData?.stwohundreddmaCal
                      }
                      extraKey="SMA"
                      ltp={techdata?.ltp}
                    />
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </TabPanel>
      </div>
    </>
  );
}
